<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable>
              <el-option v-for="item in companysList" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="$_fliterData">筛选</el-button>
            <!-- <el-button class="btn" @click="$_exportForm">导出</el-button>
            <el-button class="btn" @click="$_exportDetail">导出月报表明细</el-button>
            <el-button class="btn" @click="$_exportOldDetail">导出旧表</el-button> -->
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <!-- <el-table-column label="序号" type="index" width="50px"></el-table-column> -->
          <el-table-column label="类别" prop="TYPE_NAME" min-width="100px"></el-table-column>
          <el-table-column label="收入" prop="INCOME_FEE" min-width="100px"></el-table-column>
          <!-- <el-table-column v-for="item in kinds" :key="item.TYPE_ID" :label="item.TYPE_NAME" :prop="String(item.TYPE_ID)"></el-table-column> -->
          <el-table-column label="成本" prop="COST_FEE"></el-table-column>
          <el-table-column label="毛利" prop="PROFIT"></el-table-column>
          <el-table-column label="毛利率" prop="PROFIT_RATE"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="导出" center :visible.sync="exportVisible" width="600px">
      <el-form :model="exportForm" ref="editForm">
        <el-form-item label="导出方式：" :label-width="formLabelWidth">
          <el-radio v-model="radio" label="1">明细</el-radio>
          <el-radio v-model="radio" label="2">汇总</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导出月报表明细" center :visible.sync="exportDetailVisible" width="600px">
      <el-form :model="exportDetailForm" ref="exportDetailForm">
        <el-form-item label="选择日期：" label-width="180px">
          <el-date-picker v-model="exportDetailForm.MONTH" type="month" placeholder="选择月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="版本：" :label-width="formLabelWidth">
          <el-radio v-model="tableRadio" label="1">新版</el-radio>
          <el-radio v-model="tableRadio" label="2">旧版</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDetailVisible = false">取 消</el-button>
        <el-button @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  summary, detail, exportDetail, exportOldDetail, exportOldMonthDetail,
} from 'api/returnWare';
import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        DATE: [date(new Date(), '%F'), date(new Date(), '%F')],
      },
      companysList: [],
      tableData: [],
      kinds: [],
      customer: [],
      exportVisible: false,
      formLabelWidth: '240px',
      radio: '1',
      exportForm: {},
      exportDetailVisible: false,
      exportDetailForm: {},
      tableRadio: '1',
    };
  },
  created() {
    if (this.BUSINESS_GROSS_PROFIT_TABLE.CONDITION) {
      this.searchForm = this.BUSINESS_GROSS_PROFIT_TABLE.CONDITION;
    }
    this.queryPro();
    this.queryData();
  },
  computed: {
    BUSINESS_GROSS_PROFIT_TABLE() {
      return this.$store.state.BUSINESS_GROSS_PROFIT_TABLE;
    },
  },
  methods: {
    // 拉取客户公司和项目点
    queryPro() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 3,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.companysList = result[0].company;
        } else {
          this.companysList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出日报表明细
    $_exportDetail() {
      this.exportDetailVisible = true;
    },
    submitExport() {
      const params = {};
      if (this.exportDetailForm.MONTH != null) {
        const first = `${new Date(this.exportDetailForm.MONTH).getFullYear()
        }-${(new Date(this.exportDetailForm.MONTH).getMonth() + 1) < 10 ? (`0${new Date(this.exportDetailForm.MONTH).getMonth() + 1}`) : (new Date(this.exportDetailForm.MONTH).getMonth() + 1)}`;
        params.MONTH = first;
      }
      if (!this.exportDetailForm.MONTH) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      if (Number(this.tableRadio == 1)) {
        exportDetail(params).then((res) => {
          window.location.href = res[0].FILE_PATH;
          this.exportDetailVisible = false;
          this.$message.show({ text: '导出成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        exportOldMonthDetail(params).then((res) => {
          window.location.href = res[0].FILE_PATH;
          this.exportDetailVisible = false;
          this.$message.show({ text: '导出成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 导出
    $_exportForm() {
      if (this.searchForm.DATE) {
        this.exportVisible = true;
      } else {
        this.$message.show({ text: '请选择起始日期', type: 'error' });
      }
    },
    // 导出确认
    submitEdit() {
      if (this.radio == '2') {
        const params = {
        };
        if (this.searchForm.DATE != null) {
          const timeArr = this.setDateTimeRange(this.searchForm.DATE);
          params.START_DAY = timeArr[0];
          params.END_DAY = timeArr[1];
        }
        summary(params).then((res) => {
          if (res.length == 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
            this.exportVisible = false;
          } else {
            window.location.href = res[0].FILE_PATH;
            this.exportVisible = false;
            this.$message.show({ text: '导出成功', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
      if (this.radio == '1') {
        const params = {
        };
        if (this.searchForm.DATE) {
          params.START_DAY = this.searchForm.DATE[0];
          params.END_DAY = this.searchForm.DATE[1];
        }
        detail(params).then((res) => {
          if (res.length == 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
            this.exportVisible = false;
          } else {
            window.location.href = res[0].FILE_PATH;
            this.exportVisible = false;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 筛选
    $_fliterData() {
      if (this.searchForm.TC_ID) {
        this.queryData();
      } else {
        this.$message.show({ text: '筛选前请先选择团餐公司', type: 'warning' });
      }
    },
    // 获取界面数据
    queryData() {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 43,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.DATE) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      http.post(params).then((result) => {
        this.tableData = result;
        this.$store.dispatch('SET_BUSINESS_GROSS_PROFIT_TABLE', { CONDITION: this.searchForm });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    $_exportOldDetail() {
      const params = {};
      if (this.searchForm.DATE != null) {
        const timeArr = this.setDateTimeRange(this.searchForm.DATE);
        params.START_DAY = timeArr[0];
        params.END_DAY = timeArr[1];
      }
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      exportOldDetail(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          window.location.href = res[0].FILE_PATH;
          this.$message.show({ text: '导出成功', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/tableManage/businessGrossProfitTable.vue